
        var result = require("!!../../../../node_modules/css-loader/index.js!./tuturial-edit.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/tuturial-edit/tuturial-edit.component.css
// module id = 641
// module chunks = 0